goog.provide('el8.appshared.dialog.reassignPatient');

goog.require('el8.appservice.notifier');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.service.urls');
goog.require('el8.template.appshared.dialog.reassignPatient');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');


el8.appshared.dialog.reassignPatient = (function() {

    var docId = null;
    var successCb = null;
    var cancelCb = null;

    var that = new el8.uiwidget.FormDialog({
        autoHeight: true,
        width: 400,
        position: 'center',
        contentFn: function() {
            return el8.template.appshared.dialog.reassignPatient.content();
        }
    });
    var mindreaderOpts = el8.appshared.mindreaderOpts.patient();
    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'patientName',
                selector: ':input[name="patientName"]',
                infoText: 'type patient name...',
                newMindreader: true,
                mindreaderOpts: mindreaderOpts
            }
        ]
    });
    form.addButton('file', 'File', function(_form) {
        var selectedPatientItem = form.getMindreaderItem('patientName');
        if (selectedPatientItem)  {
            var document = getDocument();
            if (!document) {
                el8.uiwidget.alert('Error re-filing item.');
                return;
            }

            document.assignPatient({
                patientId: selectedPatientItem.id,
                successCb: function() {
                    if (successCb) { successCb(); }
                    that.hide();
                }
            });
        } else {
            el8.uiwidget.alert('Please select an existing patient chart.');
        }
    }, true);
    form.addCancelButton(function() {
        that.hide();
    }, false);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        successCb = spec.successCb || null;
        cancelCb = spec.cancelCb || null;
        docId = spec.docId || null;

        super_show.call(that);

        var mClass = el8.model.idToModelClass(docId);
        that.setTitle(el8.template.appshared.dialog.reassignPatient.title({ modelClass: mClass }));
        $('.additional-info', that.getContentElt()).text(
            el8.template.appshared.dialog.reassignPatient.addlInfoText({ modelClass: mClass })
        );

        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        if (cancelCb) { cancelCb(); }
        super_hide.call(that);
        $('.additional-info', that.getContentElt()).empty();

        successCb = null;
        cancelCb = null;
        docId = null;
    };

    function getDocument() {
        if (el8.model.idToModelClass(docId) === 'IncomingEmail') {
            return el8.practicedata.unassignedEmails.getById(docId);
        } else if (el8.model.idToModelClass(docId) === 'Report') {
            return el8.ptdata.reports.getById(docId);
        }
        return null;
    }

    return that;

})();
